(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["boostcous-product-experience"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initExperience(root) {
      /* ---- Gallery ---- */
      var main = root.querySelector('[data-bx-main]');
      var thumbs = root.querySelectorAll('[data-bx-thumb]');
      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          if (main) main.src = thumb.dataset.full;
          thumbs.forEach(function (t) { t.classList.remove('is-active'); });
          thumb.classList.add('is-active');
        });
      });

      /* ---- Nutrition modal ---- */
      var modal = root.querySelector('[data-bx-nutrition-modal]');
      var openBtn = root.querySelector('[data-bx-nutrition-open]');
      if (modal && openBtn) {
        var open = function () { modal.classList.add('is-open'); document.body.style.overflow = 'hidden'; };
        var close = function () { modal.classList.remove('is-open'); document.body.style.overflow = ''; };
        openBtn.addEventListener('click', open);
        root.querySelectorAll('[data-bx-nutrition-close]').forEach(function (el) { el.addEventListener('click', close); });
        document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
      }

      /* ---- Buy box ---- */
      var box = root.querySelector('[data-bc-buybox]');
      if (!box) return;
      var qty = box.querySelector('[data-quantity]');
      var toggle = box.querySelector('[data-sub-toggle]');
      var variantInput = box.querySelector('[name="id"]');
      var planInput = box.querySelector('[name="selling_plan"]');
      var compareEl = box.querySelector('[data-compare-price]');
      var currentEl = box.querySelector('[data-current-price]');
      var badgeEl = box.querySelector('[data-save-badge]');
      var ctaTextEl = box.querySelector('[data-cta-text]');
      if (!qty || !toggle || !variantInput || !ctaTextEl) return;

      var ctaLabel = ctaTextEl.textContent.split('—')[0].trim();
      var freqNote = qty.dataset.frequencyNote || '';

      function relabelOptions() {
        for (var i = 0; i < qty.options.length; i++) {
          var o = qty.options[i];
          var base = o.getAttribute('data-base-label') || o.textContent;
          o.textContent = (toggle.checked && freqNote) ? base + ' — ' + freqNote : base;
        }
      }

      function render() {
        var opt = qty.options[qty.selectedIndex] || qty.options[0];
        if (!opt) return;
        var d = opt.dataset;
        var onetime = !toggle.checked;
        var current = onetime ? d.onetimeCurrent : d.subCurrent;
        var compare = onetime ? (d.onetimeCompare || '') : (d.subCompare || '');
        var badge = onetime ? d.onetimeBadge : d.subBadge;

        currentEl.textContent = current || '';
        compareEl.textContent = (compare && compare !== current) ? compare : '';
        badgeEl.textContent = badge || '';
        ctaTextEl.textContent = ctaLabel + ' — ' + current;

        variantInput.value = opt.value;
        if (planInput) {
          if (!onetime && d.sellingPlan) {
            planInput.value = d.sellingPlan;
            planInput.disabled = false;
          } else {
            planInput.value = '';
            planInput.disabled = true;
          }
        }
        box.classList.toggle('is-onetime', onetime);
      }

      qty.addEventListener('change', render);
      toggle.addEventListener('change', function () { relabelOptions(); render(); });
      relabelOptions();
      render();
    }

    document.querySelectorAll('[data-bx-root]').forEach(initExperience);
    document.addEventListener('shopify:section:load', function (event) {
      var root = event.target.querySelector('[data-bx-root]');
      if (root) initExperience(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
